import React, { useState } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import Achievements from '../Achievements';

import './index.scss';
import messages from './messages';

import line13Img from '../../img/achievementDisplay/line-13.svg';

interface AchievementDisplayProps {
  title?: string;
  textHelper: string;
  displayCertificates?: boolean;
}

const AchievementDisplay: React.FC<AchievementDisplayProps> = ({
  title = '',
  textHelper = '',
  displayCertificates = true,
}) => {
  const [enabled, setEnabled] = useState<boolean>(true);

  const intl = useIntl();

  if (!enabled) {
    return null;
  }

  return (
    <>
      <div className="achievements">
        <div className="my-achievements-1 inter-light-congress-blue-22px">
          {title || intl.formatMessage(messages.title)}
        </div>
        <img className="line-13-1" src={line13Img} alt="Line 13" />
      </div>
      <div className="badges">
        <div className="badge_-container">
          <Achievements displayCertificates={displayCertificates} setEnabled={setEnabled} />
        </div>
      </div>
      {textHelper && (
        <p className="achievement-text-helper">{textHelper}</p>
      )}
    </>
  );
};

export default AchievementDisplay;
